import axios from 'axios'
import { uuidv4 } from '/@/utils/uuid'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
import cookies from 'vue-cookies'
export * from './type'

const REQUEST_ID = 'X-Request-Id'

// 全局状态管理
let isRedirecting = false
let pendingRequests: (() => void)[] = []

function getAuthToken () {
  return cookies.get(ELocalStorageKey.Token)
}

const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 12000,
})
// 清空所有待处理的请求
function clearPendingRequests () {
  pendingRequests.forEach(cancel => cancel())
  pendingRequests = []
}

// 恢复所有请求
function resumeRequests () {
  isRedirecting = false
}

instance.interceptors.request.use(
  config => {
    // 如果正在跳转，阻止新请求
    if (isRedirecting) {
      return new Promise((resolve, reject) => {
        const cancelToken = new axios.CancelToken(cancel => {
          pendingRequests.push(() => {
            cancel('请求被取消，正在跳转登录页')
          })
        })
        config.cancelToken = cancelToken
      })
    }

    config.headers[ELocalStorageKey.XJToken] = 'Bearer ' + getAuthToken()
    // config.headers[REQUEST_ID] = uuidv4()
    config.baseURL = CURRENT_CONFIG.baseURLS
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    if (response.data.code === 401 || (response.data.code === -1 && response.data.message === 'Token无效')) {
      if (!isRedirecting) {
        isRedirecting = true
        clearPendingRequests()

        localStorage.clear()
        cookies.remove(ELocalStorageKey.Token)
        console.error(response)

        // 设置跳转完成的回调
        const next = router.push('/' + ERouterName.PROJECT)
        next.then(() => {
          // 跳转完成后恢复请求
          setTimeout(() => {
            resumeRequests()
          }, 100) // 稍等100ms确保页面已加载
        }).catch(() => {
          resumeRequests()
        })
      }
      return Promise.reject(response.data)
    }
    // console.info('URL: ' + response.config.baseURL + response.config.url, '\nData: ', response.data, '\nResponse:', response)
    if (response.data.code && response.data.code !== 0 && response.data.code !== 200) {
      message.error(response.data.message || response.data.msg)
      return Promise.reject(response.data)
    }
    return response
  },
  err => {
    // 如果是被取消的请求，直接reject
    if (axios.isCancel(err)) {
      return Promise.reject(err)
    }
    if (err.response?.status === 401) {
      if (!isRedirecting) {
        isRedirecting = true
        clearPendingRequests()

        localStorage.clear()
        cookies.remove(ELocalStorageKey.Token)
        console.error(err.response)

        // 设置跳转完成的回调
        const next = router.push('/' + ERouterName.PROJECT)
        next.then(() => {
          // 跳转完成后恢复请求
          setTimeout(() => {
            resumeRequests()
          }, 100)
        }).catch(() => {
          resumeRequests()
        })
      }
      return Promise.reject(err)
    }
    const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID]
    if (requestId) {
      console.info(REQUEST_ID, '：', requestId)
    }
    console.info('url: ', err?.config?.url, `【${err?.config?.method}】 \n>>>> err: `, err)

    let description = '-'
    if (err.response?.data && err.response.data.message) {
      description = err.response.data.message
    }
    if (err.response?.data && err.response.data.result) {
      description = err.response.data.result.message || err.response.data.result.msg
    }
    // @See: https://github.com/axios/axios/issues/383
    if (!err.response || !err.response.status) {
      message.error('网络异常，请检查后端服务并重试.')
      return
    }
    if (err.response?.status !== 200) {
      message.error(`ERROR_CODE: ${err.response?.status}`)
    }
    // if (err.response?.status === 403) {
    //   // window.location.href = '/'
    // }

    return Promise.reject(err)
  },
)

export default instance
